const vP7190 = require("./304.js");
const vP71902 = require("./305.js");
exports.NUMERIC = {
  id: "Numeric",
  bit: 1,
  ccBits: [10, 12, 14]
};
exports.ALPHANUMERIC = {
  id: "Alphanumeric",
  bit: 2,
  ccBits: [9, 11, 13]
};
exports.BYTE = {
  id: "Byte",
  bit: 4,
  ccBits: [8, 16, 16]
};
exports.KANJI = {
  id: "Kanji",
  bit: 8,
  ccBits: [8, 10, 12]
};
exports.MIXED = {
  bit: -1
};
exports.getCharCountIndicator = function (p7191, p7192) {
  if (!p7191.ccBits) {
    throw new Error("Invalid mode: " + p7191);
  }
  if (!vP7190.isValid(p7192)) {
    throw new Error("Invalid version: " + p7192);
  }
  if (p7192 >= 1 && p7192 < 10) {
    return p7191.ccBits[0];
  } else if (p7192 < 27) {
    return p7191.ccBits[1];
  } else {
    return p7191.ccBits[2];
  }
};
exports.getBestModeForData = function (p7193) {
  if (vP71902.testNumeric(p7193)) {
    return exports.NUMERIC;
  } else if (vP71902.testAlphanumeric(p7193)) {
    return exports.ALPHANUMERIC;
  } else if (vP71902.testKanji(p7193)) {
    return exports.KANJI;
  } else {
    return exports.BYTE;
  }
};
exports.toString = function (p7194) {
  if (p7194 && p7194.id) {
    return p7194.id;
  }
  throw new Error("Invalid mode");
};
exports.isValid = function (p7195) {
  return p7195 && p7195.bit && p7195.ccBits;
};
function f1098(p7196) {
  if (typeof p7196 != "string") {
    throw new Error("Param is not a string");
  }
  const v6043 = p7196.toLowerCase();
  switch (v6043) {
    case "numeric":
      return exports.NUMERIC;
    case "alphanumeric":
      return exports.ALPHANUMERIC;
    case "kanji":
      return exports.KANJI;
    case "byte":
      return exports.BYTE;
    default:
      throw new Error("Unknown mode: " + p7196);
  }
}
exports.from = function (p7197, p7198) {
  if (exports.isValid(p7197)) {
    return p7197;
  }
  try {
    return f1098(p7197);
  } catch (e63) {
    return p7198;
  }
};